var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yd-dialog",
    {
      attrs: {
        title: "添加保险信息",
        visible: _vm.dialogVisible,
        "append-to-body": "",
        "destroy-on-close": "",
        width: "900px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.closeClick,
      },
    },
    [
      _c("div", { staticClass: "tipsBox" }, [
        _c("i", { staticClass: "el-icon-warning-outline" }),
        _c("span", [
          _vm._v(
            "\n      1.保费、保额请输入数字，如：20万保额请输入2000000；\n      2.需上传交强险、承运人责任险、商业保险，并上传保单文件"
          ),
        ]),
      ]),
      _c(
        "el-form",
        {
          ref: "form",
          attrs: { "label-width": "150px", model: _vm.form, rules: _vm.rules },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "保单图片", required: "" } },
            [
              _c("upload-image", {
                attrs: {
                  isMultiple: true,
                  code: "vehicle-insurance",
                  file: _vm.carInsuranceImg,
                  instructionText: "上传保单照片/PDF",
                  accept: ".jpg,.jpeg,.png,.JPG,.JPEG,.PBG,.pdf",
                },
                on: {
                  uploadSuccess: _vm.getcarInsuranceImg,
                  remove: _vm.getcarInsuranceImg,
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "保险类型：", prop: "insuranceType" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "200px" },
                  attrs: {
                    filterable: "",
                    placeholder: "请选择",
                    clearable: "",
                  },
                  model: {
                    value: _vm.form.insuranceType,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "insuranceType", $$v)
                    },
                    expression: "form.insuranceType",
                  },
                },
                _vm._l(_vm.insuranceTypeList, function (item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.label, value: item.key },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "保险号：", prop: "policyNo" } },
            [
              _c("el-input", {
                staticStyle: { width: "200px" },
                attrs: { clearable: "" },
                model: {
                  value: _vm.form.policyNo,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "policyNo", $$v)
                  },
                  expression: "form.policyNo",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "保险公司：", prop: "insuranceCompany" } },
            [
              _c("el-input", {
                staticStyle: { width: "200px" },
                attrs: { clearable: "" },
                model: {
                  value: _vm.form.insuranceCompany,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "insuranceCompany", $$v)
                  },
                  expression: "form.insuranceCompany",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "保费：", prop: "premium" } },
            [
              _c("el-input", {
                staticStyle: { width: "200px" },
                attrs: { clearable: "" },
                model: {
                  value: _vm.form.premium,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "premium", $$v)
                  },
                  expression: "form.premium",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "保额：", prop: "sumAssured" } },
            [
              _c("el-input", {
                staticStyle: { width: "200px" },
                attrs: { clearable: "" },
                model: {
                  value: _vm.form.sumAssured,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "sumAssured", $$v)
                  },
                  expression: "form.sumAssured",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: { label: "保险生效日期：", prop: "insurancePeriodBegin" },
            },
            [
              _c("el-date-picker", {
                staticStyle: { width: "200px" },
                attrs: {
                  type: "date",
                  placeholder: "选择日期",
                  format: "yyyy 年 MM 月 dd 日",
                  "value-format": "yyyyMMdd",
                },
                model: {
                  value: _vm.form.insurancePeriodBegin,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "insurancePeriodBegin", $$v)
                  },
                  expression: "form.insurancePeriodBegin",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "is-required",
              attrs: { label: "保险到期时间：", prop: "insurancePeriodEnd" },
            },
            [
              _c("el-date-picker", {
                staticStyle: { width: "200px" },
                attrs: {
                  type: "date",
                  placeholder: "选择日期",
                  format: "yyyy 年 MM 月 dd 日",
                  "value-format": "yyyyMMdd",
                },
                model: {
                  value: _vm.form.insurancePeriodEnd,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "insurancePeriodEnd", $$v)
                  },
                  expression: "form.insurancePeriodEnd",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.closeClick } }, [_vm._v("取 消")]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.saveCarInsurance } },
            [_vm._v("确 定")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }